import { render, staticRenderFns } from "./services.vue?vue&type=template&id=61969b8f&"
var script = {}
import style0 from "./services.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61969b8f')) {
      api.createRecord('61969b8f', component.options)
    } else {
      api.reload('61969b8f', component.options)
    }
    module.hot.accept("./services.vue?vue&type=template&id=61969b8f&", function () {
      api.rerender('61969b8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/services/services.vue"
export default component.exports